import React, { Component } from 'react';
import './GlobalLeaderboard.css';

import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Header from '../../components/partials/HeaderComponent';
import Footer from '../../components/partials/FooterComponent';
import axios from 'axios';
import { connect } from 'react-redux';
import Spinner from '../MerchandiseStore/Spinner/Spinner';

class GlobalLeaderboard extends Component {

    state = {
        count: 0,
        currUsers: [],
        loading: false
    }

    componentDidMount() {
        this.getLeaderboard();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.count !== this.state.count) {
            this.getLeaderboard();
        }
    }

    getLeaderboard = async () => {
        this.setState({
            loading: true
        })
        await axios.get('https://server.codeium.tech/leaderboard/global', {
                params: {
                    count: this.state.count
                }
            })
            .then(res => {
                // console.log(res);
                this.setState({
                    currUsers: res.data.msg
                })
            })
            .catch(err => {
                // console.log(err);
            })
        this.setState({
            loading: false
        })
    }

    nextPage = () => {
        if(this.state.currUsers === null || this.state.currUsers.length === 0) {
            return;
        }
        if(this.state.currUsers.length == 0) return;
        this.setState(prevState => ({
            count: prevState.count + 25
        }))
    }

    prevPage = () => {
        if(this.state.count === 0) {
            return;
        }
        if(this.state.count == 0) return;
        this.setState(prevState => ({
            count: prevState.count - 25
        }))
    }

    render() {
        return (
            <>
                <Header />
                <div className="my-5 p-1 container">
                    <h1 className="primary-heading ml-1 ml-sm-0">Leaderboard</h1>
                    {
                        this.state.loading ? <Spinner /> : (
                            <div className="row">
                                <div className="col-12">
                                    <div className="tab-container p-2 p-md-3">
                                    <div className="row mt-3">
                                            <div className="col-12">
                                                <table className="table  table-md Problem_Table">
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">Username</th>
                                                            <th scope="col">Problems Solved</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.currUsers?.map((user, index) => {
                                                                let styles = null;
                                                                if(user.username === this.props.username) {
                                                                    styles = {backgroundColor: "rgb(221, 238, 255)"};
                                                                }
                                                                return (
                                                                    <tr>
                                                                        <td style={styles}>{(index + 1) + (this.state.count) * 1}</td>
                                                                        <td style={styles}>{user.username}</td>
                                                                        <td style={styles}>{user.total_count}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-11 d-flex justify-content-end PageNav">
                                                    <FaChevronLeft onClick={this.prevPage} className="mt-1 mr-1 Icons"/>
                                                    <p className="PageCount">
                                                        {this.state.count !== 0 ? <span className="PagePoint" onClick={this.prevPage}>{this.state.count / 25}</span> : null}
                                                        <span className="active">
                                                            {this.state.count / 25 + 1}
                                                        </span>
                                                        {
                                                            this.state.currUsers.length !== 0 ? 
                                                            <span className="PagePoint" onClick={this.nextPage}>
                                                                {this.state.count / 25 + 2}
                                                            </span> : null
                                                        }
                                                    </p>
                                                    <FaChevronRight onClick={this.nextPage} className="mt-1 ml-1 Icons"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
                <Footer />
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        username: state.auth.username
    }
}

export default connect(mapStateToProps)(GlobalLeaderboard);